module.exports = __webpack_public_path__ + "img/workflow_.7d97a07a.png";